import xss from 'xss';

import { LOGIN_URL, PLAT_MAP_URL } from '@/constants/urls';

/**
 * Checks if the URL is valid and not from a different origin
 * @param from The URL to check
 * @param router The router
 * @returns The URL if it is valid, otherwise the login URL or the plat map URL
 */
export function checkForRedirect(router, from = '') {
  if (!from) return '';

  // eslint-disable-next-line no-script-url
  if (from.startsWith('javascript:')) {
    router.push(LOGIN_URL);
  }
  // Make sure the URL is not from a different origin
  try {
    const url = new URL(from);
    if (url.origin !== window.location.origin) {
      return PLAT_MAP_URL;
    }

    return xss(from);
  } catch {
    return xss(from);
  }
}
